import moment from "moment";
import { formatNumber } from "./essential";
import PaymentReceipt from "../../Component/PaymentReceipt";
import invoice from "../../assets/img/invoice.jpg"
import { viewInvoice, editHouse, editSubscriber } from "../roles"
export const houseColumns = (
  loadCategories,
  loadStatuses,
  setter,
  rowData,
  roles
) => {
  return [
    {
      name: "Id",
      cell: (row) => <div className='hover'>{row["id"]}</div>,
    },
    {
      name: "Account",
      cell: (row) => <div>{row["accountId"]}</div>,
    },
    { name: "Category", cell: (row) => row["category"]["name"] },
    {
      name: "Owner Id",
      cell: (row) => row["ownerSubscriberId"],
    },
    {
      name: "Monthly Fee",
      cell: (row) => `${formatNumber(row["securityFeeAmount"])} RWF`,
    },
    { name: "Status", cell: (row) => row["status"]["name"] },
    {
      name: "Created On",
      cell: (row) => moment(row["createdAt"]).format("DD-MM-YYYY"),
    },
    {
      name: roles?.some((role) => role.id === editHouse) ? "Actions" : "",
      cell: (row) => (
        <div className='d-flex justify-content-center'>
          {roles?.some((role) => role.id === editHouse) && (
            <i
              style={{ color: "#0000ff", cursor: "pointer" }}
              className='fa fa-pen'
              onClick={() => {
                loadCategories();
                loadStatuses();
                setter(true);
                rowData(row);
              }}
            />
          )}
        </div>
      ),
    },
  ];
};
export const billsColumns = (roles, storeEntireRow, showPaymentInvoice) => {
  const Columns = [
    {
      name: "Id",
      cell: (row) => row["id"],
    },
    {
      name: "Account Id",
      cell: (row) => <div>{row["accountId"]}</div>,
    },
    {
      name: "House Id",
      cell: (row) => <div>{row["houseId"]}</div>,
    },
    {
      name: "Period",
      cell: (row) => row["period"],
    },
    {
      name: "Bill Date",
      cell: (row) => moment(row?.datetime).format("DD-MM-YYYY"),
    },
    { name: "Bill Type", cell: (row) => row?.type?.name },
    { name: "Amount", cell: (row) => `${formatNumber(row["amount"])} RWF` },
    { name: "Status", cell: (row) => row["status"]["name"] },
    {
      name: roles?.some((role) => role.id === viewInvoice)
        ? "Invoice"
        : "",
      cell: (row) =>
        roles?.some((role) => role.id === viewInvoice) && (
          <img
            width={90}
            height={90}
            src={invoice}
            onClick={() => {
              showPaymentInvoice(true);
              storeEntireRow(row);
            }}
            style={{ cursor: "pointer" }}
          />
        ),
    },
  ];
  return Columns;
};
export const paymentColumns = (address) => {
  return [
    { name: "Id", cell: (row) => row["id"] },
    { name: "Account Id", cell: (row) => row["accountId"] },
    {
      name: "Datetime",
      cell: (row) => moment(row["datetime"]).format("DD-MM-YYYY hh:mm:ss A"),
    },
    {
      name: (
        <div className='sc-dQoVA huizgM'>
          Collection
          <br /> Account
        </div>
      ),
      cell: (row) => row["collectionAccount"]["name"],
    },
    { name: "TID", cell: (row) => row["transactionId"] },
    { name: "FRID", cell: (row) => row["financialReferenceId"] },
    { name: "Payer", cell: (row) => row["payer"]["paymentNumber"] },
    { name: "Amount", cell: (row) => `${formatNumber(row["amount"])} RWF` },
    { name: "Info", cell: (row) => row["paymentInfo"] },
    {
      name: "Receipt",
      cell: (row) => (
        <PaymentReceipt
          address={address}
          date={row["datetime"]}
          accountId={row["accountId"]}
          amount={row["amount"]}
          title='Generate payment receipt'
        />
      ),
    },
  ];
};

export const subscriberColumns = (setter,roles) => {
  const columns = [
    {
      name: "Id",
      cell: (row) => row["id"],
    },
    {
      name: "Names",
      cell: (row) => `${row["firstName"]} ${row["lastName"]}`,
    },
    {
      name: "Phone Number",
      cell: (row) => row["phoneNumber"],
    },
    {
      name: "NID",
      cell: (row) => row["nid"],
    },
    {
      name: "TIN",
      cell: (row) => row["tin"],
    },
    {
      name: "Type",
      cell: (row) => row?.type?.name,
    },
    {
      name: "Status",
      cell: (row) => row?.status?.name,
    },
    {
      name: "Registered on",
      cell: (row) => moment(row["createdAt"]).format("DD-MM-YYYY"),
    },
    {
      name: roles?.some((role) => role.id === editSubscriber)
        ? "Edit Subscriber"
        : "",
      cell: () => (
        <div className='d-flex justify-content-center' style={{ width: "80%" }}>
          {roles?.some((role) => role.id === editSubscriber) ? (
            <i
              style={{ color: "#0000ff", cursor: "pointer" }}
              className='fa fa-pen'
              onClick={() => setter(true)}
            />
          ) : null}
        </div>
      ),
    },
  ];
  return columns;
};
